import { CartApplication, CartItemEnrollmentDetails } from '@/Model/checkout/cart/types'
import { guardianResponseModel } from '@/Model/model'
import ApplicationConfirmation from '@/components/familyPortal/popupComponents/applicationConfirmation/ApplicationConfirmation.vue'
import APP_CONST from '@/constants/AppConst'
import { ScreenText } from '@/lang/ScreenText'
import applicationStore from '@/store/modules/applications/applicationStore'
import CartStoreModule from '@/store/modules/checkout/cart/module'
import commonEntry from '@/store/modules/commonEntry'
import formsStore from '@/store/modules/forms/formsStore'
import APP_UTILITIES from '@/utilities/commonFunctions'
import { ElForm } from 'element-ui/types/form'
import UIkit from 'uikit'
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import GenetateFormItem from '../GenerateFormItem/GenerateFormItem.vue'
import { getDecodedToken } from '@/services/common/httpClient'
import ToastType from '@/Model/toastTypes'

@Component({
  name: 'generate-form',
  components: {
    GenetateFormItem,
    'confirmation-popup': ApplicationConfirmation
  }
})
export default class GenerateForm extends Vue {
  APP_CONST = APP_CONST
  private objScreenText: ScreenText = new ScreenText()
  public models: any = {}
  public rules: any = {}
  public currentRoute: any = ''
  public validationExcludedRoutes: string[] = ['Preview', 'Design']
  private autoSaveTimer: any = 0
  private initialFormData: any = {}
  public isPartTwoAutoSaved: boolean = false
  public userSubmitted: boolean = true
  public guardianFields: string[] = [
    'guardianaddressField',
    'guardianaddressField_1',
    'guardianaddressField_2'
  ]
  public isSubmitted: boolean = false
  public isBannerShow: boolean = false
  public is400BannerShow: boolean = false
  public noOfErrors: any = []
  public positionofError: number = 0
  public disablePrevButton: boolean = false
  public disableNextButton: boolean = false
  public nextPreviousButtonCalled: boolean = false
  public dropdownTypes: string[] = ['select', 'dropdown']
  public outsideClick: boolean = false
  public guardianFieldRules: any = APP_CONST.FORM_BUILDER_FIELD_RULES
  public isRedBannerShown: boolean = false
  public guardianErrorMessage: any = ''
  public emergencyErrorMessage: any = ''
  public authoriseErrorMessage: any = ''
  public static readonly INPUT_SELECTOR = '.el-form-item__error:not([style*="display: none"])'

  duplicateFieldsData: any = {
    guardians: {
      firstName: {},
      lastName: {}
    },
    emergency: {
      firstName: {},
      lastName: {}
    },
    authorized: {
      firstName: {},
      lastName: {}
    }
  }

  private validationTriggerCallbackFn = () => {
    this.validateCartApplicationForm()
  }

  private saveApplicationFormsCallbackFn = async () => {
    await this.saveApplicationForms(true)
  }

  @Prop()
  value!: any

  @Prop()
  insite!: any

  @Prop()
  formIndex!: number

  /* istanbul ignore next */
  get sitesList() {
    return applicationStore.sitesList
  }

  get applicationParts() {
    return formsStore.applicationsPartsData.forms
  }

  get applicationsList() {
    return formsStore.applicationsData
  }

  get formData() {
    const formObject = this.applicationParts[this.formIndex]
      ? this.applicationParts[this.formIndex].source
      : { list: [], config: {} }
    return formObject
  }

  get elasticEnrollmentId() {
    return formsStore.getElasticEnrollmentId
  }

  get getConsentAgreement() {
    return formsStore.getConsentAgreementMap
  }

  get formsList() {
    return formsStore.formsList
  }

  /* istanbul ignore next */
  get userDetail(): any {
    return commonEntry.userDetail
  }

  get siteIds() {
    const siteIds: number[] = []
    if (this.sitesList.length) {
      this.sitesList.forEach((session) => {
        if (session.selected) {
          siteIds.push(session.sessionId)
        }
      })
    }
    return siteIds
  }

  get isDirty() {
    return JSON.stringify(this.formsList) != JSON.stringify(this.initialFormData)
  }

  get formWidgetList() {
    return formsStore.formWidgetList
  }

  get formTwoFetchFlag() {
    return formsStore.partTwoFormsFetchFlag
  }

  get firstGuardianDetails() {
    return formsStore.firstGuardianModelsList
  }

  get guardianFirstEmailModel() {
    return this.firstGuardianDetails.email
  }

  get guardianFirstNameModel() {
    return this.firstGuardianDetails.firstName
  }

  get guardianLastNameModel() {
    return this.firstGuardianDetails.lastName
  }

  get hideAgeBool() {
    return formsStore.hideAgeProp
  }

  get selectedChildId() {
    return applicationStore.selectedChild.id
  }

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key)
  }

  mounted() {
    this.onMounted()
  }

  onMounted() {
    /* check for restricting multiple elastic calls for multiple forms */
    if (
      this.applicationParts &&
      this.formIndex >= 0 &&
      this.applicationParts[this.applicationParts.length - 1].formSequence == this.formIndex &&
      this.selectedChildId != '-1'
    ) {
      this.autoSave()
    }
    this.autoValidate()
    formsStore.getUserDetails().then((res: any) => {
      const guardianrecord: guardianResponseModel = res.data
      this.addGuardianDatainModel(guardianrecord)
    })
  }

  addGuardianDatainModel(guardianResponse: guardianResponseModel) {
    if (guardianResponse) {
      if (
        this.firstGuardianDetails.firstName &&
        !this.models[this.firstGuardianDetails.firstName]
      ) {
        this.models[this.firstGuardianDetails.firstName] = guardianResponse.firstName
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.firstName,
          value: guardianResponse.firstName
        })
      }
      if (this.firstGuardianDetails.lastName && !this.models[this.firstGuardianDetails.lastName]) {
        this.models[this.firstGuardianDetails.lastName] = guardianResponse.lastName
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.lastName,
          value: guardianResponse.lastName
        })
      }
      if (this.firstGuardianDetails.email && !this.models[this.firstGuardianDetails.email]) {
        this.models[this.firstGuardianDetails.email] = guardianResponse.email
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.email,
          value: guardianResponse.email
        })
      }
      if (
        this.firstGuardianDetails.primaryGaurdian &&
        !this.models[this.firstGuardianDetails.primaryGaurdian]
      ) {
        this.models[this.firstGuardianDetails.primaryGaurdian] = guardianResponse.primaryGuardian
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.primaryGaurdian,
          value: guardianResponse.primaryGuardian
        })
      }
      if (
        this.firstGuardianDetails.birthdate &&
        !this.models[this.firstGuardianDetails.birthdate] &&
        guardianResponse.birthDate
      ) {
        const birthDate: any = guardianResponse.birthDate
        this.models[this.firstGuardianDetails.birthdate] = birthDate
          .replace(/\//gi, ' - ')
          .slice(0, 14)
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.birthdate,
          value: birthDate.replace(/\//gi, ' - ').slice(0, 14)
        })
      }
      if (this.firstGuardianDetails.relation && guardianResponse.relation) {
        this.models[this.firstGuardianDetails.relation] = guardianResponse.relation
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.relation,
          value: guardianResponse.relation
        })
      }
      if (this.firstGuardianDetails.phone && !this.models[this.firstGuardianDetails.phone]) {
        this.models[this.firstGuardianDetails.phone] = guardianResponse.phone
          ? this.getFormattedPhone(guardianResponse.phone)
          : ''
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.phone,
          value: guardianResponse.phone ? this.getFormattedPhone(guardianResponse.phone) : ''
        })
      }
      if (this.firstGuardianDetails.phonetype) {
        this.models[this.firstGuardianDetails.phonetype] = guardianResponse.phoneType
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.phonetype,
          value: guardianResponse.phoneType
        })
      }
      if (
        this.firstGuardianDetails.secondaryPhone &&
        !this.models[this.firstGuardianDetails.secondaryPhone]
      ) {
        this.models[this.firstGuardianDetails.secondaryPhone] = guardianResponse.secondaryPhone
          ? this.getFormattedPhone(guardianResponse.secondaryPhone)
          : ''
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.secondaryPhone,
          value: guardianResponse.secondaryPhone
            ? this.getFormattedPhone(guardianResponse.secondaryPhone)
            : ''
        })
      }
      if (this.firstGuardianDetails.secondaryPhoneType) {
        this.models[this.firstGuardianDetails.secondaryPhoneType] =
          guardianResponse.secondaryPhoneType
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.secondaryPhoneType,
          value: guardianResponse.secondaryPhoneType
        })
      }
      if (
        this.firstGuardianDetails.addressLine1 &&
        guardianResponse.address &&
        !this.models[this.firstGuardianDetails.addressLine1]
      ) {
        this.models[this.firstGuardianDetails.addressLine1] = guardianResponse.address.address1
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.addressLine1,
          value: guardianResponse.address.address1
        })
      }
      if (
        this.firstGuardianDetails.addressLine2 &&
        guardianResponse.address &&
        !this.models[this.firstGuardianDetails.addressLine2]
      ) {
        this.models[this.firstGuardianDetails.addressLine2] = guardianResponse.address.address2
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.addressLine2,
          value: guardianResponse.address.address2
        })
      }
      if (
        this.firstGuardianDetails.city &&
        guardianResponse.address &&
        !this.models[this.firstGuardianDetails.city]
      ) {
        this.models[this.firstGuardianDetails.city] = guardianResponse.address.city
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.city,
          value: guardianResponse.address.city
        })
      }
      if (this.firstGuardianDetails.state && guardianResponse.address) {
        this.models[this.firstGuardianDetails.state] = guardianResponse.address.state
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.state,
          value: guardianResponse.address.state
        })
      }
      if (
        this.firstGuardianDetails.zipCode &&
        guardianResponse.address &&
        !this.models[this.firstGuardianDetails.zipCode]
      ) {
        this.models[this.firstGuardianDetails.zipCode] = guardianResponse.address.zip
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.zipCode,
          value: guardianResponse.address.zip
        })
      }
      if (this.firstGuardianDetails.homeLanguage) {
        this.models[this.firstGuardianDetails.homeLanguage] = guardianResponse.homeLanguage
        formsStore.mutateFirstGuardianData({
          model: this.firstGuardianDetails.homeLanguage,
          value: guardianResponse.homeLanguage
        })
      }
    }
  }

  getFormattedPhone(phone: string) {
    let val = phone
    val = val.replace(/\D/g, '').substring(0, 10)
    const zip = val && val.substring(0, 3)
    const middle = val && val.substring(3, 6)
    const last = val && val.substring(6, 10)
    if (val.length == 0) {
      val = ''
    } else if (val.length < 4) {
      val = `(${zip}`
    } else if (val.length < 7) {
      val = `(${zip}) ${middle}`
    } else {
      val = `(${zip}) ${middle}-${last}`
    }
    return val
  }

  autosavePartTwo() {
    if (this.formTwoFetchFlag) {
      const formsList: any = {
        enrollments: JSON.stringify({
          formsList: this.applicationsList,
          isFinalSubmit: false,
          isPartOneFetched: true,
          siteIds: JSON.parse(localStorage.all_selected_sites),
          guardianId: this.userDetail.id,
          scholar: this.formsList.scholar.scholarName
        }),
        elasticEnrollmentId: this.elasticEnrollmentId
      }
      if (JSON.parse(localStorage.scholar_selected) == true) {
        formsList.elasticEnrollmentId = ''
      }
      formsStore.saveApplicationForms(formsList)
      formsStore.updatePartTwoFetchFlag(false)
    }
  }

  requiredConsentVerification(): void {
    const originalConsentReferences = this.formData.list
      .filter((element: any) => element.type.includes('consentInfo'))
      .map((element: any) => [
        element.columns[0].list[0].required,
        element.columns[0].list[0].required
      ])
      .flat()

    for (let i = 0, matchCounter = 0; i < this.formWidgetList.length; i++) {
      if (this.formWidgetList[i].type === 'consentcheckbox') {
        this.formWidgetList[i].options.required = originalConsentReferences[matchCounter]
        matchCounter++
      }
    }
  }

  autoValidate() {
    if (this.formWidgetList) {
      this.formData && this.requiredConsentVerification()

      for (let i = 0; i < this.formWidgetList.length; i++) {
        const formValidatedState =
          this.formWidgetList[i].options.required &&
          (!this.formWidgetList[i].options.defaultValue ||
            this.formWidgetList[i].options.defaultValue == 'Select')
        formsStore.mutateFormValidate(formValidatedState)
        if (formValidatedState) {
          break
        }
      }
    }
  }

  created() {
    this.attachExternalListeners()

    this.currentRoute = this.$route ? this.$route.name : ''

    this.generateModle(this.formData.list)

    this.initialFormData = this.formsList

    document.addEventListener(
      'click',
      ($event: any) => {
        if ($event.target.id == APP_CONST.SUBMIT_FORM_TEXT && this.userSubmitted) {
          this.submitForm()
        }
      },
      false
    )
  }

  resetScholarBirthdate() {
    const childBirthdateWidgetIndex = formsStore.widgetList.findIndex(
      (x: any) => x.name === APP_CONST.FORM_INPUT_CHILD_BIRTHDATE
    )
    const childBirthdateWidget = formsStore.widgetList[childBirthdateWidgetIndex]
    childBirthdateWidget.options.defaultValue = ''
    formsStore.mutateSelectedWidgetItem(childBirthdateWidget, childBirthdateWidgetIndex)

    const generateFormRef = this.$refs.generateForm as any
    const scholarBirthdateFormItem = generateFormRef.fields.find((x: any) =>
      x.prop.startsWith(APP_CONST.FORM_INPUT_CHILD_BIRTHDATE)
    )
    const scholarBirthdateFormInput = scholarBirthdateFormItem.$children.find(
      (x: any) => x.$attrs.name === APP_CONST.FORM_INPUT_CHILD_BIRTHDATE
    )

    formsStore.saveCurrentBirthDate('')
    scholarBirthdateFormItem.resetField()
    scholarBirthdateFormInput.clear()
  }

  resetScholar() {
    const inputKeys = [
      APP_CONST.FORM_INPUT_CHILD_BIRTHDATE,
      APP_CONST.FORM_INPUT_CHILD_FIRSTNAME,
      APP_CONST.FORM_INPUT_CHILD_LASTNAME
    ]

    for (const inputKey of inputKeys) {
      const widgetIndex = formsStore.widgetList.findIndex((x: any) => x.name === inputKey)
      const widget = formsStore.widgetList[widgetIndex]
      widget.options.defaultValue = ''
      formsStore.mutateSelectedWidgetItem(widget, widgetIndex)

      const generateFormRef = this.$refs.generateForm as any
      const formItem = generateFormRef.fields.find((x: any) => x.prop.startsWith(inputKey))
      const formInput = formItem.$children.find((x: any) => x.$attrs.name === inputKey)

      formItem.resetField()
      formInput.clear()
    }

    formsStore.saveCurrentBirthDate('')
  }

  compareDates(today: any, birthDate: any) {
    return (
      birthDate &&
      today &&
      today.getDate() == birthDate.getDate() &&
      today.getMonth() == birthDate.getMonth() &&
      today.getFullYear() == birthDate.getFullYear()
    )
  }

  triggerApplicationScholarFirstLastDobChangedEvent() {
    Vue.prototype.$eventHub.$emit(
      APP_CONST.CART_APPLICATION_SCHOLAR_FN_LN_DOB_CHANGED_TRIGGER_EVENT
    )
  }

  // NOTE: all of these properties are required because this method is
  // bound to a validator, which requires this signature
  // ref: https://element-plus.org/en-US/component/form.html#custom-validation-rules
  validateIfScholarAlreadyApplied(rule: any, value: any, callback: any) {
    this.triggerApplicationScholarFirstLastDobChangedEvent()
    callback()
  }

  validateBirthDate(rule: any, birthDate: any, callback: any) {
    if (rule && rule.field && rule.field.startsWith(APP_CONST.FORM_INPUT_CHILD_BIRTHDATE)) {
      Vue.prototype.$eventHub.$emit(
        APP_CONST.CART_APPLICATION_SCHOLAR_BIRTHDATE_CHANGED_TRIGGER_EVENT,
        birthDate
      )
    }

    if (birthDate && birthDate.length == 14) {
      birthDate = new Date(birthDate.replace(/\s/g, '').replace(/-/g, '/'))
      const today = new Date()
      if (birthDate > today || this.compareDates(today, birthDate)) {
        callback(
          new Error('Please enter valid birth date. (Ingrese una fecha de nacimiento válida.)')
        )
      } else {
        callback()
      }
    } else if (birthDate && birthDate.length < 14) {
      callback(
        new Error(
          'Be sure to enter MM-DD-YYYY. (Asegúrate de escribir la fecha de nacimiento (mes, día, año) MM-DD-AAAA).'
        )
      )
    } else {
      callback()
    }
  }

  validateEmail(rule: any, value: string, callback: any) {
    if (value && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      callback(new Error('Invalid email'))
    } else {
      callback()
    }
  }

  /**
   * Function for validating if a two guardians share the same email
   */
  validateDoubleEmailForGuardian(rule: any, value: string, callback: any) {
    // We filter the form data fields to use only the ones for guardian emails
    const filteredRules = this.formData.list.filter((val: { model: string }) =>
      val.model.includes('guardian_email')
    )

    // If more than 1 guardian is present we verify if their emails are equal, if they are we throw an error
    if (filteredRules.length > 1) {
      const guardianEmail1 = filteredRules[0].options.defaultValue
      const guardianEmail2 = filteredRules[1].options.defaultValue
      if (guardianEmail1 === guardianEmail2) {
        callback(new Error(APP_CONST.DUPLICATE_GUARDIAN_EMAIL))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }

  filterPhoneNumberRules(genList: any) {
    genList.forEach((element: any) => {
      if (element.type == 'phoneNumberType') {
        element.columns.forEach((col: any) => {
          col.list.forEach((list: any) => {
            if (
              list.name === 'guardian_phone' ||
              list.name === 'guardian_secondary_phone' ||
              list.name === 'scholar_phone' ||
              list.name === 'authorized_phone' ||
              list.name === 'emergency_phone'
            ) {
              list.rules.splice(1, 1)
            }
          })
        })
      }
    })
  }

  handleDplicateRecords(handleDplicateRecords?: any) {
    this.checkDuplicateRecord(this.duplicateFieldsData.guardians, 'guardian', handleDplicateRecords)
    this.checkDuplicateRecord(
      this.duplicateFieldsData.emergency,
      'emergency',
      handleDplicateRecords
    )
    this.checkDuplicateRecord(
      this.duplicateFieldsData.authorized,
      'authorized',
      handleDplicateRecords
    )

    setTimeout(() => {
      const errorElements: any = document.querySelectorAll('.el-form-item__error')
      if (errorElements) {
        errorElements.forEach((element: any, index: number) => {
          element.style.position = 'relative'
          element.style.lineHeight = '1.2'
        })
      }
    }, 100)
  }

  generateModle(genList: any) {
    this.filterPhoneNumberRules(genList)
    for (let i = 0; i < genList.length; i++) {
      if (
        genList[i].name &&
        genList[i].name.includes('guardian_email') &&
        genList[i].order &&
        genList[i].order === 'guardian_2'
      ) {
        // Register validators for email and double guardian validation, only applies to the second guardian since the first guardian
        // defaults their email to the one on the account
        genList[i].rules[0] = { validator: this.validateDoubleEmailForGuardian, trigger: 'blur' }
      }
      if (genList[i].name == 'guardian_email') {
        genList[i].rules.push({ validator: this.validateEmail, trigger: 'blur' })
      }
      if (genList[i].name == 'scholar_email') {
        genList[i].rules.push({ validator: this.validateEmail, trigger: 'blur' })
      }
      if (genList[i].name == 'guardian_birthdate') {
        genList[i].rules.push({ validator: this.validateBirthDate, trigger: 'blur' })
      }
      if (genList[i].name == 'scholar_birthdate') {
        genList[i].rules.push({
          validator: (rule: any, birthDate: any, callback: any) => {
            this.triggerApplicationScholarFirstLastDobChangedEvent()
            const firstTimeApplicant = applicationStore.duplicateApplicationErrorType === null
            if (firstTimeApplicant) {
              this.validateBirthDate(rule, birthDate, callback)
            } else {
              callback()
            }
          },
          trigger: 'blur'
        })
      }
      if (['scholar_firstname', 'scholar_lastname'].includes(genList[i].name)) {
        genList[i].rules.push({ validator: this.validateIfScholarAlreadyApplied, trigger: 'blur' })
      }
      if ((genList[i].order && genList[i].order == APP_CONST.GUARDIAN_ONE) || !genList[i].order) {
        if (
          this.userDetail.lastName &&
          genList[i].order &&
          genList[i].order == APP_CONST.GUARDIAN_ONE &&
          genList[i].name == APP_CONST.GUARDIAN_LASTNAME
        ) {
          genList[i].options.defaultValue = this.userDetail.lastName
        }
        this.checkandupdateGurdian(genList[i])
      }

      if (genList[i].name == 'guardian_secondarytype') {
        genList[i].options.required = false
      }
      if (
        genList[i].elmType === 'grid' ||
        genList[i].elmType === 'addressGrid' ||
        genList[i].elmType === 'emergencyGrid'
      ) {
        genList[i].columns.forEach((item: any) => {
          this.generateModle(item.list)
        })
      } else {
        if (
          this.guardianFieldRules[genList[i].name] &&
          genList[i].rules &&
          (!genList[i].rules.length ||
            (genList[i].rules.length &&
              !genList[i].rules.includes(this.guardianFieldRules[genList[i].name])))
        ) {
          genList[i].rules.push(this.guardianFieldRules[genList[i].name])
        }
        if (
          this.dropdownTypes.includes(genList[i].type) &&
          genList[i].required == true &&
          genList[i].options.defaultValue == 'Select'
        ) {
          genList[i].options.defaultValue = ''
          genList[i].rules[0] = { ...genList[i].rules[0], trigger: 'change' }
        }
        if (this.value && Object.keys(this.value).indexOf(genList[i].model) >= 0) {
          this.models[genList[i].model] = this.value[genList[i].model]
        } else {
          if (genList[i].type === 'blank') {
            this.$set(
              this.models,
              genList[i].model,
              genList[i].options.defaultType === 'String'
                ? ''
                : genList[i].options.defaultType === 'Object'
                  ? {}
                  : []
            )
          } else {
            this.models[genList[i].model] = genList[i].options.defaultValue
          }
        }

        if (this.rules[genList[i].model]) {
          this.rules[genList[i].model] = [
            ...this.rules[genList[i].model],
            ...genList[i].rules.map((item: any) => {
              if (!genList[i].options.required && item.required) {
                item.required = false
              }
              if (item.pattern) {
                return {
                  ...item,
                  pattern: APP_UTILITIES.parseStringToRegExp(item.pattern)
                }
              } else {
                return { ...item }
              }
            })
          ]
        } else {
          if (genList[i].rules) {
            this.rules[genList[i].model] = [
              ...genList[i].rules.map((item: any) => {
                if (!genList[i].options.required && item.required) {
                  item.required = false
                }
                if (item.pattern) {
                  return {
                    ...item,
                    pattern: APP_UTILITIES.parseStringToRegExp(item.pattern)
                  }
                } else {
                  return { ...item }
                }
              })
            ]
          }
        }
      }
    }
  }

  checkandupdateGurdian(genList: any) {
    if (
      genList.model &&
      genList.model.includes(APP_CONST.GUARDIAN_EMAIL) &&
      !this.firstGuardianDetails.email
    ) {
      formsStore.saveGuardianDetails({ email: genList.model })
      genList.options.disabled = true
    }
    if (
      genList.model &&
      genList.model.includes(APP_CONST.GUARDIAN_FIRSTNAME) &&
      !this.firstGuardianDetails.firstName
    ) {
      formsStore.saveGuardianDetails({ firstName: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes(APP_CONST.GUARDIAN_LASTNAME) &&
      !this.firstGuardianDetails.lastName
    ) {
      formsStore.saveGuardianDetails({ lastName: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_birthdate') &&
      !this.firstGuardianDetails.birthdate
    ) {
      formsStore.saveGuardianDetails({ birthdate: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_relation') &&
      !this.firstGuardianDetails.relation
    ) {
      formsStore.saveGuardianDetails({ relation: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_primary') &&
      !this.firstGuardianDetails.primaryGaurdian
    ) {
      formsStore.saveGuardianDetails({ primaryGaurdian: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_phone') &&
      !this.firstGuardianDetails.phone
    ) {
      formsStore.saveGuardianDetails({ phone: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_phonetype') &&
      !this.firstGuardianDetails.phonetype
    ) {
      formsStore.saveGuardianDetails({ phonetype: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_secondary_phone') &&
      !this.firstGuardianDetails.secondaryPhone
    ) {
      formsStore.saveGuardianDetails({ secondaryPhone: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_secondarytype') &&
      !this.firstGuardianDetails.secondaryPhoneType
    ) {
      formsStore.saveGuardianDetails({ secondaryPhoneType: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_address1') &&
      !this.firstGuardianDetails.addressLine1
    ) {
      formsStore.saveGuardianDetails({ addressLine1: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_address2') &&
      !this.firstGuardianDetails.addressLine2
    ) {
      formsStore.saveGuardianDetails({ addressLine2: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_city') &&
      !this.firstGuardianDetails.city
    ) {
      formsStore.saveGuardianDetails({ city: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_state') &&
      !this.firstGuardianDetails.state
    ) {
      formsStore.saveGuardianDetails({ state: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_zipcode') &&
      !this.firstGuardianDetails.zipCode
    ) {
      formsStore.saveGuardianDetails({ zipCode: genList.model })
    }
    if (
      genList.model &&
      genList.model.includes('guardian_language') &&
      !this.firstGuardianDetails.homeLanguage
    ) {
      formsStore.saveGuardianDetails({ homeLanguage: genList.model })
    }
  }

  get currentCartApplication(): CartApplication | null {
    return CartStoreModule.currentlySelectedCartApplication
  }

  get canSave(): boolean {
    const isFirstNameValid = !!this.formsList.scholar.scholarName.scholar_firstname
    const isLastNameValid = !!this.formsList.scholar.scholarName.scholar_lastname
    const dobValue = this.formsList.scholar.scholarbirthdateField.scholar_birthdate
    let isDobValid = false
    if (dobValue) {
      // Because the validation function does not return an error if the birth date is falsy
      this.validateBirthDate(null, dobValue, (error?: Error) => {
        if (!error) {
          isDobValid = true
        }
      })
    }
    return isFirstNameValid && isLastNameValid && isDobValid
  }

  async saveApplicationForms(forceAutoSave = false) {
    if (
      (this.isDirty || forceAutoSave) &&
      this.applicationsList != undefined &&
      Object.keys(this.applicationsList).length
    ) {
      if (!this.canSave) {
        return
      }
      let formsList: any = {
        enrollments: JSON.stringify({
          formsList: this.applicationsList,
          isFinalSubmit: false,
          siteIds: JSON.parse(
            localStorage.all_selected_sites /*site ids on single application, or total cart session ids*/
          ),
          guardianId: this.userDetail.id,
          scholar: this.formsList.scholar.scholarName,
          scholardob: this.formsList.scholar.scholarbirthdateField.scholar_birthdate
        }),
        elasticEnrollmentId: this.elasticEnrollmentId
      }
      if (JSON.parse(localStorage.scholar_selected) == true) {
        formsList.elasticEnrollmentId = formsStore.scholarElasticEnrollmentId
          ? formsStore.scholarElasticEnrollmentId
          : this.elasticEnrollmentId
      }
      if (this.currentCartApplication) {
        const trimmedDOB = this.formsList.scholar.scholarbirthdateField.scholar_birthdate
        const cartItemEnrollmentDetails: CartItemEnrollmentDetails = {
          cartItemId: this.currentCartApplication.cartItemId,
          guardianUserId: this.userDetail.id,
          scholarFirstName: this.formsList.scholar.scholarName.scholar_firstname,
          scholarLastName: this.formsList.scholar.scholarName.scholar_lastname,
          scholarDateOfBirth: trimmedDOB
        }
        formsList = { ...formsList, cartItemEnrollmentDetails }
      }
      await formsStore.saveApplicationForms(formsList)
      this.initialFormData = this.formsList
    }
  }

  private attachExternalListeners() {
    this.$root.$on(
      APP_CONST.CART_APPLICATION_VALIDATION_TRIGGER_EVENT,
      this.validationTriggerCallbackFn
    )
    this.$root.$on(
      APP_CONST.CART_APPLICATION_SAVE_APPLICATION_FORMS_TRIGGER_EVENT,
      this.saveApplicationFormsCallbackFn
    )
    Vue.prototype.$eventHub.$on(
      APP_CONST.CART_APPLICATION_RESET_SCHOLAR_BIRTHDATE_TRIGGER_EVENT,
      this.resetScholarBirthdate
    )
    Vue.prototype.$eventHub.$on(
      APP_CONST.CART_APPLICATION_RESET_SCHOLAR_TRIGGER_EVENT,
      this.resetScholar
    )
  }

  private detachExternalListeners() {
    this.$root.$off(
      APP_CONST.CART_APPLICATION_VALIDATION_TRIGGER_EVENT,
      this.validationTriggerCallbackFn
    )
    this.$root.$off(
      APP_CONST.CART_APPLICATION_SAVE_APPLICATION_FORMS_TRIGGER_EVENT,
      this.saveApplicationFormsCallbackFn
    )
    Vue.prototype.$eventHub.$off(
      APP_CONST.CART_APPLICATION_RESET_SCHOLAR_BIRTHDATE_TRIGGER_EVENT,
      this.resetScholarBirthdate
    )
    Vue.prototype.$eventHub.$off(
      APP_CONST.CART_APPLICATION_RESET_SCHOLAR_TRIGGER_EVENT,
      this.resetScholar
    )
  }

  autoSave() {
    this.$nextTick(function () {
      this.autoSaveTimer = window.setInterval(() => {
        this.saveApplicationForms()
      }, APP_CONST.APPLICATION_AUTO_SAVE_INTERVAL)
    })
  }

  validateDuplicateGuardian(rule: any, value: string, callback: any) {
    if (value && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      callback(new Error('Invalid email'))
    } else {
      callback()
    }
  }

  validateDuplicateCheck(rule: any, value: string, callback: any) {
    if (rule.field.includes('guardian')) {
      callback(new Error(this.guardianErrorMessage))
    }
    if (rule.field.includes('emergency')) {
      callback(new Error(this.emergencyErrorMessage))
    }
    if (rule.field.includes('authorized')) {
      callback(new Error(this.authoriseErrorMessage))
    }
  }

  validateDuplicateUserNameCheck(rule: any, value: string, callback: any) {
    callback(new Error(' '))
  }

  getFieldsData(fieldsList: any) {
    const innerObj: any = {}
    const modelsStr: any = []
    const str: any = []
    let innerCount: number = 0
    for (const field in fieldsList) {
      innerCount = 0
      for (const elementData in fieldsList[field]) {
        const elemVal = fieldsList[field][elementData].value
        str[innerCount] = {
          value:
            str[innerCount] && str[innerCount].value ? str[innerCount].value + elemVal : elemVal
        }
        modelsStr[innerCount] = {
          models:
            modelsStr[innerCount] && modelsStr[innerCount].models
              ? `${modelsStr[innerCount].models}-${elementData}`
              : elementData
        }
        innerObj[innerCount] = {
          model: elementData,
          value: str[innerCount].value,
          modelsList: modelsStr[innerCount].models
        }
        innerCount++
      }
    }
    return innerObj
  }

  matchDuplicateRecord(userObj: any, previousRecord: any) {
    let currentRecord: any = ''
    let isRecordMatched: boolean = false
    for (const latRecord of Object.values(userObj)) {
      currentRecord = latRecord
      if (
        currentRecord.value &&
        previousRecord.value &&
        currentRecord.value.toLowerCase() == previousRecord.value.toLowerCase() &&
        currentRecord.model != previousRecord.model
      ) {
        isRecordMatched = true
      } else if (
        currentRecord.value &&
        previousRecord.value &&
        currentRecord.value.toLowerCase() != previousRecord.value.toLowerCase() &&
        currentRecord.model != previousRecord.model
      ) {
        // isRecordMatched = false
      }
    }
    return isRecordMatched
  }

  checkDuplicateRecord(fieldsList: any, type: string, elementSelected?: any) {
    const innerObj: any = this.getFieldsData(fieldsList)
    let firstMatchStatus: boolean = false
    if (innerObj) {
      let previousRecord: any = ''
      for (const fieldData of Object.values(innerObj)) {
        previousRecord = fieldData
        firstMatchStatus = this.matchDuplicateRecord(innerObj, previousRecord)

        switch (type) {
          case 'guardian':
            if (firstMatchStatus) {
              this.guardianErrorMessage = APP_CONST.DUPLICATE_GUARDIAN_RECORD
            }
            break
          case 'emergency':
            if (firstMatchStatus) {
              this.emergencyErrorMessage = APP_CONST.DUPLICATE_EMERGENCY_RECORD
            }
            break
          case 'authorized':
            if (firstMatchStatus) {
              this.authoriseErrorMessage = APP_CONST.DUPLICATE_AUTHORIZED_RECORD
            }
            break
          default:
            break
        }
        if (!firstMatchStatus) {
          const modelsArr: string[] = previousRecord.modelsList.split('-')
          modelsArr.forEach((model: string) => {
            let isValid: Boolean = false
            if (this.rules[model] && this.rules[model].length > 1 && model.includes('_phone_')) {
              isValid = true
            } else if (
              this.rules[model] &&
              this.rules[model].length > 4 &&
              (model.includes('_firstname') || model.includes('_lastname'))
            ) {
              isValid = true
            }
            if (isValid && this.rules[model]) {
              this.rules[model].pop()
              const generateFormRef = this.$refs.generateForm as any
              generateFormRef.validateField(model)
            }
          })
        } else {
          const modelsArr: string[] = previousRecord.modelsList.split('-')
          if (this.models[modelsArr[0]] && this.models[modelsArr[1]]) {
            modelsArr.forEach((model: string) => {
              const generateFormRef = this.$refs.generateForm as any
              if (
                this.rules[model] &&
                this.rules[model].length < 5 &&
                model.includes('_lastname')
              ) {
                this.rules[model].push({ validator: this.validateDuplicateCheck, trigger: 'blur' })
                generateFormRef.validateField(model)
              }
              if (
                this.rules[model] &&
                this.rules[model].length == 5 &&
                model.includes('_lastname')
              ) {
                this.rules[model][4] = { validator: this.validateDuplicateCheck, trigger: 'blur' }
                generateFormRef.validateField(model)
              } else if (
                this.rules[model] &&
                this.rules[model].length < 6 &&
                (model.includes('_firstname') || model.includes('_lastname'))
              ) {
                this.rules[model].push({
                  validator: this.validateDuplicateUserNameCheck,
                  trigger: 'blur'
                })
                generateFormRef.validateField(model)
              }
            })
          }
        }
      }
    }
  }

  @Ref('generateForm') generateFormRef!: ElForm

  async validateCartApplicationForm() {
    const valid = await this.validateForm()
    this.$root.$emit(APP_CONST.CART_APPLICATION_VALIDATION_RAN_EVENT, valid)
  }

  // This logic was existing, just lifted into its own function
  saveFormsList() {
    const formsList: any = {
      enrollments: JSON.stringify({
        formsList: this.applicationsList,
        isFinalSubmit: true,
        siteIds: JSON.parse(localStorage.all_selected_sites),
        guardianId: this.userDetail.id
      }),
      elasticEnrollmentId: this.elasticEnrollmentId
    }
    if (JSON.parse(localStorage.scholar_selected) == true) {
      formsList.elasticEnrollmentId = formsStore.scholarElasticEnrollmentId
        ? formsStore.scholarElasticEnrollmentId
        : this.elasticEnrollmentId
    }
    formsStore.saveApplicationForms(formsList).then((response: any) => {
      this.isSubmitted = false
      if (response.status == APP_CONST.RESPONSE_200) {
        window.clearInterval(this.autoSaveTimer)
        this.formsList.scholarMapping.siteIds = JSON.parse(localStorage.all_selected_sites)
        if (this.formsList.scholarMapping.elasticSubmissionId == '') {
          this.formsList.scholarMapping.elasticSubmissionId = response.data
        }
        if (APP_UTILITIES.getCookie('outStandingItems')) {
          formsStore.saveFinalSubmitPartSecond(this.formsList).then((res: any) => {
            if (res.status == APP_CONST.RESPONSE_200) {
              formsStore.resetApplication()
              formsStore.updateScholarData({})
              formsStore.saveCurrentBirthDate('')
              formsStore.updateCurrentFormField({ name: '', value: '' })
              if (this.isNextButton) {
                this.nextPage()
              } else {
                this.$router.push('/')
              }
            } else if (res.status != APP_CONST.RESPONSE_200) {
              this.userSubmitted = true
            }
          })
        } else {
          formsStore.saveFinalApplicationForms(this.formsList).then(async (res: any) => {
            if (
              res.status == APP_CONST.RESPONSE_200 &&
              UIkit &&
              UIkit.modal('#modal-application-sent')
            ) {
              formsStore.saveCurrentBirthDate('')
              formsStore.updateCurrentFormField({ name: '', value: '' })
              UIkit.modal('#modal-application-sent').show()
              const el: any = document.getElementById('modal-application-sent')
              /* istanbul ignore else */
              if (el) {
                el.classList.add('uk-flex', 'uk-open')
                el.style.display = 'block !important'
              }
              this.userSubmitted = true
              const { userId: user_id }: any = await getDecodedToken()
              /* istanbul ignore else */
              if (user_id) {
                await commonEntry.fetchUserDetails(parseInt(user_id))
              }
            } else if (res.status != APP_CONST.RESPONSE_200) {
              this.userSubmitted = true
              if (res.status === 400 && res.data === 'Validation_ResponseListGreaterThanZero') {
                this.is400BannerShow = true
              }
            }
          })
        }
      } else if (response.status != APP_CONST.RESPONSE_200) {
        this.userSubmitted = true
      }
    })
  }

  // This logic was existing, just lifted into its own function and cleaned up
  async validateForm(): Promise<boolean> {
    this.isBannerShow = false
    this.is400BannerShow = false
    this.userSubmitted = false
    this.handleDplicateRecords()
    let valid = false
    let result = false
    await this.generateFormRef
      .validate()
      .then((validateResult) => {
        valid = validateResult
      })
      .catch(() => {
        valid = false
      })
    this.isSubmitted = true
    const errors = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
    const isMobile = APP_UTILITIES.isMobile()
    if (
      valid &&
      this.formIndex == this.applicationParts.length - 1 &&
      errors &&
      errors.length == 0
    ) {
      this.noOfErrors = []
      this.isBannerShow = isMobile ? false : true
      const inputdoc = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      inputdoc.forEach((element) => {
        element.classList.remove('error-outlined-banner')
      })
      result = true
    } else {
      this.userSubmitted = true
      setTimeout(() => {
        const inputdoc = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
        this.noOfErrors = inputdoc
        this.isBannerShow = isMobile ? false : true
        if (isMobile) {
          APP_UTILITIES.showToastMessage(
            `${this.getScreenText('ERROR_BANNER_MESSAGE')}`,
            ToastType.Error
          )
        }
        this.movetoFirstError()
        const errorElement: any = document.getElementById('dropdown-error')
        if (
          errorElement &&
          errorElement.nextElementSibling &&
          errorElement.nextElementSibling.classList.contains('el-form-item__error')
        ) {
          errorElement.nextElementSibling.style.display = 'none'
        }
      }, 300)
    }
    formsStore.resetGuardianDetails()
    return result
  }

  async submitForm() {
    const valid = await this.validateForm().catch((e) => console.error(e))
    if (valid) {
      this.saveFormsList()
    }
  }

  preLabel() {
    this.nextPreviousButtonCalled = true
    this.disablePrevButton = false
    this.disableNextButton = false
    this.noOfErrors = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      ? document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      : ''
    let valuecheked: boolean = false
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1
        valuecheked = true
      }
    }
    this.positionofError = valuecheked ? this.positionofError : this.positionofError - 1
    if (this.positionofError !== 0 && this.positionofError <= this.noOfErrors.length) {
      this.disablePrevButton = false
      this.positionofError = valuecheked ? this.positionofError - 1 : this.positionofError
      this.navigateToLabel(
        this.noOfErrors[this.positionofError - 1],
        this.noOfErrors[this.positionofError]
      )
    }
    if (this.positionofError == 1) {
      this.disablePrevButton = true
    }
  }

  nextLabel() {
    this.nextPreviousButtonCalled = true
    this.disableNextButton = false
    this.disablePrevButton = false
    let valuecheked: boolean = false
    this.noOfErrors = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      ? document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      : ''
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1
        valuecheked = true
      }
    }
    if (this.positionofError - 1 <= this.noOfErrors.length - 1) {
      this.disableNextButton = false
      this.navigateToLabel(
        this.noOfErrors[valuecheked ? this.positionofError : this.positionofError - 1],
        this.noOfErrors[valuecheked ? this.positionofError - 1 : this.positionofError - 2]
      )
      this.positionofError = valuecheked ? this.positionofError + 1 : this.positionofError
    }
    if (this.positionofError == this.noOfErrors.length) {
      this.disableNextButton = true
    }
  }

  movetoFirstError() {
    this.disableNextButton = false
    this.disablePrevButton = true
    const inputdoc: any = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
    inputdoc.forEach((element: any) => {
      element.classList.remove('error-outlined-banner')
    })
    this.noOfErrors = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      ? document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
      : ''
    this.navigateToLabel(this.noOfErrors[0])
    this.positionofError = APP_CONST.ONE
    if (this.noOfErrors.length == APP_CONST.ONE) {
      this.disableNextButton = true
    }
  }

  navigateToLabel(element: HTMLElement, lastelement?: HTMLElement) {
    const inputdoc: any = document.querySelectorAll('.is-success .el-input__inner')
    inputdoc.forEach((element: any) => {
      element.classList.remove('error-outlined-banner')
    })
    if (element) {
      this.isRedBannerShown = true
      element.focus()
      element.classList.add('error-outlined-banner')
      window.scrollBy({
        top:
          document.documentElement.clientWidth > 992
            ? element.getBoundingClientRect().top - 210
            : document.documentElement.clientWidth > 830
              ? element.getBoundingClientRect().top - 230
              : document.documentElement.clientWidth > 768
                ? element.getBoundingClientRect().top - 250
                : document.documentElement.clientWidth > 550
                  ? element.getBoundingClientRect().top - 230
                  : document.documentElement.clientWidth > 465
                    ? element.getBoundingClientRect().top - 250
                    : document.documentElement.clientWidth > 419
                      ? element.getBoundingClientRect().top - 250
                      : document.documentElement.clientWidth > 390
                        ? element.getBoundingClientRect().top - 260
                        : element.getBoundingClientRect().top - 270,
        behavior: 'smooth'
      })
    }
    if (lastelement) {
      lastelement.classList.remove('error-outlined-banner')
    }
  }

  updateErrorCount(nextPreviousButtonCalled: boolean) {
    setTimeout(() => {
      if (!nextPreviousButtonCalled && this.isBannerShow) {
        this.outsideClick = false
        this.disableNextButton = false
        this.disablePrevButton = false
        this.noOfErrors = document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
          ? document.querySelectorAll(GenerateForm.INPUT_SELECTOR)
          : ''
        const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
          ? document.getElementsByClassName('error-outlined-banner')
          : document.getElementsByClassName(
              'form-dropdown-title form-dropdown-name el-input__inner error-outlined-banner'
            )
        const activeElement: any = document.activeElement
        if (focussedElement[0] && focussedElement[0] != activeElement) {
          focussedElement[0].classList.remove('error-outlined-banner')
        }
        if (
          activeElement &&
          activeElement != document.body &&
          (Object.entries(this.noOfErrors).find((x) => x[1] == activeElement) ||
            Object.entries(this.noOfErrors).find(
              (x) => x[1] == activeElement.parentElement.parentElement.previousSibling
            ))
        ) {
          if (activeElement.className.indexOf('dropdown-menu') != -1) {
            activeElement.parentElement.parentElement.previousSibling.classList.add(
              'error-outlined-banner'
            )
            window.scrollBy({
              top:
                document.documentElement.clientWidth > 992
                  ? activeElement.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? activeElement.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? activeElement.getBoundingClientRect().top - 250
                      : document.documentElement.clientWidth > 550
                        ? activeElement.getBoundingClientRect().top - 230
                        : document.documentElement.clientWidth > 465
                          ? activeElement.getBoundingClientRect().top - 250
                          : document.documentElement.clientWidth > 419
                            ? activeElement.getBoundingClientRect().top - 250
                            : document.documentElement.clientWidth > 390
                              ? activeElement.getBoundingClientRect().top - 260
                              : activeElement.getBoundingClientRect().top - 270,
              behavior: 'smooth'
            })
          } else if (activeElement.type == 'text') {
            activeElement.classList.add('error-outlined-banner')
            activeElement && activeElement.focus()
            window.scrollBy({
              top:
                document.documentElement.clientWidth > 992
                  ? activeElement.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? activeElement.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? activeElement.getBoundingClientRect().top - 250
                      : document.documentElement.clientWidth > 550
                        ? activeElement.getBoundingClientRect().top - 230
                        : document.documentElement.clientWidth > 465
                          ? activeElement.getBoundingClientRect().top - 250
                          : document.documentElement.clientWidth > 419
                            ? activeElement.getBoundingClientRect().top - 250
                            : document.documentElement.clientWidth > 390
                              ? activeElement.getBoundingClientRect().top - 260
                              : activeElement.getBoundingClientRect().top - 270,
              behavior: 'smooth'
            })
          } else {
            this.outsideClick = true
          }
        } else {
          this.outsideClick = true
        }

        for (let index = 0; index < this.noOfErrors.length; index++) {
          if (this.noOfErrors[index] == focussedElement[0]) {
            this.positionofError = index + 1
          }
        }
        if (
          this.outsideClick &&
          activeElement.className.indexOf('dropdown-menu') == -1 &&
          activeElement.type != 'text'
        ) {
          const element: any = this.noOfErrors[this.positionofError - 1]
          const lastelement: any = this.noOfErrors[this.positionofError - 2]
          if (element) {
            const inputdoc: any = document.querySelectorAll('.is-success .el-input__inner')
            inputdoc.forEach((element: any) => {
              element.classList.remove('error-outlined-banner')
            })

            element.classList.add('error-outlined-banner')
            element && element.focus()
            window.scrollBy({
              top:
                document.documentElement.clientWidth > 992
                  ? element.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? element.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? element.getBoundingClientRect().top - 250
                      : document.documentElement.clientWidth > 550
                        ? element.getBoundingClientRect().top - 230
                        : document.documentElement.clientWidth > 465
                          ? element.getBoundingClientRect().top - 250
                          : document.documentElement.clientWidth > 419
                            ? element.getBoundingClientRect().top - 250
                            : document.documentElement.clientWidth > 390
                              ? element.getBoundingClientRect().top - 260
                              : element.getBoundingClientRect().top - 270,
              behavior: 'smooth'
            })

            if (lastelement) {
              lastelement.classList.remove('error-outlined-banner')
            }
          } else if (!element && lastelement) {
            const inputdoc: any = document.querySelectorAll('.is-success .el-input__inner')
            inputdoc.forEach((element: any) => {
              element.classList.remove('error-outlined-banner')
            })
            lastelement && lastelement.classList.add('error-outlined-banner')
            lastelement && lastelement.focus()
            window.scrollBy({
              top:
                document.documentElement.clientWidth > 992
                  ? lastelement.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? lastelement.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? lastelement.getBoundingClientRect().top - 250
                      : document.documentElement.clientWidth > 550
                        ? lastelement.getBoundingClientRect().top - 230
                        : document.documentElement.clientWidth > 465
                          ? lastelement.getBoundingClientRect().top - 250
                          : document.documentElement.clientWidth > 419
                            ? lastelement.getBoundingClientRect().top - 250
                            : document.documentElement.clientWidth > 390
                              ? lastelement.getBoundingClientRect().top - 260
                              : lastelement.getBoundingClientRect().top - 270,
              behavior: 'smooth'
            })
            this.positionofError = this.positionofError - 1
          }
        }
        if (this.positionofError == this.noOfErrors.length) {
          this.disableNextButton = true
        }
        if (this.positionofError == APP_CONST.ONE) {
          this.disablePrevButton = true
        }
      }
      this.outsideClick = false
      this.nextPreviousButtonCalled = false
    }, 300)
  }

  /* istanbul ignore next */
  get isNextButton() {
    if (
      APP_UTILITIES.getCookie('outStandingItems') ||
      APP_UTILITIES.getCookie('outStandingItemIndex')
    ) {
      const application: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItems') || '')
      const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '')
      if (application[currentIndex] && application[currentIndex].isDocumentSubmitted) {
        if (application.length == currentIndex + 1) {
          return false
        } else {
          return true
        }
      }
      return true
    } else {
      return false
    }
  }

  nextPage() {
    const application: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItems') || '')
    const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '')
    if (!this.isNextButton) {
      this.$router.push(APP_CONST.APP_ROUTES.DASHBOARD.path)
    } else if (currentIndex || currentIndex == 0) {
      if (application[currentIndex + 1] && application[currentIndex + 1].isDocumentSubmitted) {
        formsStore.resetApplication()
        applicationStore.updatePartIndex({ submissions: application, index: currentIndex + 1 })
      } else {
        this.$router.push(APP_CONST.APP_ROUTES.APPLICATION_UPLOAD_DOCUMENTS.path)
      }
    }
  }

  checkSingleCheckbox(event: any) {
    this.$nextTick(() => {
      event.item.columns[event.colIndex].list[event.i].columns.forEach(
        (innerClmElm: any, innerClmInd: number) => {
          if (innerClmElm && innerClmElm.list) {
            innerClmElm.list.forEach((innerListElm: any, ind: number) => {
              innerListElm.options.defaultValue = false
            })
          }
        }
      )
      event.item.columns[event.colIndex].list[event.i].columns[event.ind].list[
        event.innerIndex
      ].options.defaultValue = true
    })
  }

  handleTest() {
    // let generateForm = this.$refs.generateForm as any;
    // this.getData().then((data : any) => {
    //   this.$alert(data, '').catch(e=>{})
    //   this.$refs.widgetPreview.end()
    // }).catch((e : any) => {
    //   this.$refs.widgetPreview.end()
    // })
  }

  reset() {
    const generateFormRef = this.$refs.generateForm as any
    generateFormRef.resetFields()
  }

  onInputChange(value: any, field: any) {
    this.$emit('on-change', field, value, this.models)
  }

  @Watch('value', { deep: true })
  watchvalue(val: any) {
    this.models = { ...this.models, ...val }
  }

  @Watch('models', { deep: true })
  watchModels(val: any) {
    if (val) {
      for (const model in val) {
        if (model.includes('guardian_firstname')) {
          this.duplicateFieldsData.guardians.firstName = {
            ...this.duplicateFieldsData.guardians.firstName,
            [model]: { value: val[model] }
          }
        }
        if (model.includes('guardian_lastname')) {
          this.duplicateFieldsData.guardians.lastName = {
            ...this.duplicateFieldsData.guardians.lastName,
            [model]: { value: val[model] }
          }
        }
        if (model.includes('emergency_firstname')) {
          this.duplicateFieldsData.emergency.firstName = {
            ...this.duplicateFieldsData.emergency.firstName,
            [model]: { value: val[model] }
          }
        }
        if (model.includes('emergency_lastname')) {
          this.duplicateFieldsData.emergency.lastName = {
            ...this.duplicateFieldsData.emergency.lastName,
            [model]: { value: val[model] }
          }
        }
        if (model.includes('authorized_firstname')) {
          this.duplicateFieldsData.authorized.firstName = {
            ...this.duplicateFieldsData.authorized.firstName,
            [model]: { value: val[model] }
          }
        }
        if (model.includes('authorized_lastname')) {
          this.duplicateFieldsData.authorized.lastName = {
            ...this.duplicateFieldsData.authorized.lastName,
            [model]: { value: val[model] }
          }
        }
      }
    }
  }

  @Watch('userDetail', { deep: true })
  watchUser(val: any) {
    if (this.guardianFirstEmailModel || this.guardianFirstNameModel || this.guardianLastNameModel) {
      if (this.guardianFirstEmailModel && !this.models[this.guardianFirstEmailModel]) {
        this.models[this.guardianFirstEmailModel] = val.email
      }
      if (this.guardianFirstNameModel && !this.models[this.guardianFirstNameModel]) {
        this.models[this.guardianFirstNameModel] = val.firstName
      }
      if (this.guardianLastNameModel && !this.models[this.guardianLastNameModel]) {
        this.models[this.guardianLastNameModel] = val.lastName
      }
    }
  }

  onDestroy() {
    clearInterval(this.autoSaveTimer)
    this.detachExternalListeners()
  }

  destroyed() {
    this.onDestroy()
  }
}
